<template>
  <div>


<!--       <el-main> -->
          <el-table
              :data="tableData"
              style="width: 100%;margin-top: 5%;"
              :row-class-name="tableRowClassName">

              <el-table-column
                prop="Property_Name"
                label="资产名称"
                width="180">
              </el-table-column>

              <el-table-column
                prop="Property_Time"
                label="购入时间"
                width="180">
              </el-table-column>

              <el-table-column
                prop="Property_Num"
                label="规格型号">
              </el-table-column>

              <el-table-column
                prop="Property_Id"
                label="资产编号">
              </el-table-column>

              <el-table-column
                prop="Property_Where"
                label="资产存放地">
              </el-table-column>


              <el-table-column
                prop="Property_Schedule"
                label="负责人">
              </el-table-column>


              <el-table-column
                prop="Property_PrintTitle"
                label="标签是否被检查">
              </el-table-column>

              <el-table-column
                prop="Property_PrintName"
                label="标签打印资产名称">
              </el-table-column>


            </el-table>


   </div>
</template>

<script>
  export default {
     name: 'Finaish',
     data () {
       return {
            tableData: [{
                    Property_Name: '汉生吸尘器',
                    Property_Time: '2020-12-31',
                    Property_Num:'汉生',
                    Property_Id: 'py20201231022',
                    Property_Where:'XXX法院底楼档案室',
                    Property_Schedule:'刘映岑',
                    Property_PrintTitle:'是',
                    Property_PrintName:'汉生吸尘器',
                  },{
                    Property_Name: '白奥除湿机',
                    Property_Time: '2020-12-31',
                    Property_Num:'百奥YDA890EB',
                    Property_Id: 'py20201231021',
                    Property_Where:'XXX法院底楼档案室',
                    Property_Schedule:'刘映岑',
                    Property_PrintTitle:'是',
                    Property_PrintName:'白奥除湿机',
                  },
                  ]}

     },
     methods: {

     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Wait/Finaish.vue